import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home'; // صفحة جديدة للصفحة الرئيسية
import About from './pages/About';
import Projects from './pages/Projects';
import ProjectDetails from './pages/ProjectDetails';
import Services from './pages/Services';
import Books from './pages/Books';
import Clients from './pages/Clients';
import Contact from './pages/Contact';
import Blogs from './pages/Blogs';
import BlogDetails from './pages/BlogDetails';
import FAG from './pages/FAG';
import Support from './pages/Support'

import ScrollToTopButton from './components/ScrollToTopButton';

function App() {
  return (
    <Router>
      <div style={{ direction: 'rtl', fontFamily: 'Arial, sans-serif', minHeight: '100vh' }}>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:projectId" element={<ProjectDetails />} />
          <Route path="/services" element={<Services />} />
          <Route path="/books" element={<Books />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:id" element={<BlogDetails />} />
          <Route path="/faq" element={<FAG />} />
          <Route path="/support" element={<Support />} />
        </Routes>
        <ScrollToTopButton />

        <Footer />
      </div>
    </Router>
  );
}

export default App;